module.exports = __webpack_public_path__ + "static/media/bonuscard.2dcb5b0b.png";